<template>
  <div v-if="Object.keys(groupActions).length > 0">
    <div class="col-sm-4 col-md-4 col-lg-4">
      <div class="list-group action-list-group">
        <button class="list-group-item" style="width: 100%; text-align: left;" @click="open = true">
          <i class="mdi mdi-swap-horizontal list-btn btn-primary"></i> groepsacties openenen
        </button>
      </div>
    </div>
    <a-modal v-model="open" :footer="null" width="600" @cancel="reset">
      <a-list v-if="!atSettings">
        <a-list-item v-for="(action, key) in groupActions" :key="action.name">
          <a-list-item-meta :title="action.title || 'Titel niet bekend'">
            <span slot="description">
              Beschikbaar voor berekening: {{ action.count }}
              <span v-if="success.includes(key)" class="text-success">
                <br>
                <small>
                  De actie is gestart. Je kunt deze pagina nu verlaten.
                </small>
              </span>
            </span>
          </a-list-item-meta>
          <span slot="actions">
            <a-button size="small" @click="act(key)" :loading="loading.includes(key)" :disabled="success.includes(key)"
                      v-if="action.settings === null" type="primary">
              Start actie
            </a-button>
            <a-button size="small" @click="goToSettings(action,key)" :loading="loading.includes(key)"
                      :disabled="success.includes(key)" v-else>
              Volgende
            </a-button>
          </span>
        </a-list-item>
      </a-list>
      <GroupActionSettingsComponent @open="atSettings = $event.value" :open="!!atSettings" :settings="settings"
                                    :loading="loadingSettings" :errors="errors"
                                    @act="act(atSettings, $event.value)"></GroupActionSettingsComponent>
    </a-modal>
  </div>
</template>

<script>
import groupActionApi from '~/api/group_action.js';
import GroupActionSettingsComponent from "./GroupActionSettingsComponent";


export default {
  props: {
    searchId: {
      type: Number
    }
  },
  data() {
    return {
      open: false,
      loading: [],
      success: [],
      groupActions: [],
      loadingGroupActions: false,
      loadingSettings: false,
      atSettings: null,
      settings: null,

      errors: {}
    }
  },
  components: {
    GroupActionSettingsComponent
  },
  methods: {
    async act(actionName, settings) {
      this.loading.push(actionName);
      try {
        await groupActionApi.startGroupAction(this.searchId, actionName, settings)

        this.$notification['success']({
          message: 'De actie is begonnen.'
        })
        this.success.push(actionName);

        this.reset();
      } catch (e) {
        this.$notification['warning']({
          message: 'Er ging iets fout met het opstarten van de actie.'
        })

        this.errors = e.response.data.error.errors;
      } finally {
        this.loading.splice(this.loading.indexOf(actionName), 1);
      }
    },
    async fetchGroupActionsWithCount() {
      if (!this.searchId) return;

      this.loadingGroupActions = true;
      try {
        this.groupActions = await groupActionApi.getAvailableGroupActions(this.searchId);
      } catch (e) {
        this.$notification['warning']({
          message: 'Er ging iets fout met het ophalen van de beschikbare acties.'
        })
      } finally {
        this.loadingGroupActions = false;
      }
    },
    async goToSettings(action, key) {
      this.atSettings = key;
      this.settings = action.settings;
    },
    reset() {
      this.settings = null;
      this.atSettings = null;
      this.errors = {};
      this.open = false;
    }
  },
  mounted() {
    if (this.searchId !== -1) {
      this.fetchGroupActionsWithCount();
    }
  }
}
</script>

<style scoped>

</style>
